(function(){
  var THRESH = 8000;
  var dw, itemsEl, shipEl, barEl, totEl;
  var cartState = null, queue = Promise.resolve(), pending = 0;
  function fmt(c){ var s=(c/100).toFixed(3).replace(/0+$/,'').replace(/\.$/,''); return s.replace('.', ',') + ' DT'; }
  function open(){ if(dw){ dw.setAttribute('data-open','1'); document.body.style.overflow='hidden'; } }
  function close(){ if(dw){ dw.setAttribute('data-open','0'); document.body.style.overflow=''; } }
  function post(url, body){
    return fetch(url, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); });
  }
  // Aucun pack présélectionné : on ramène le client sur le choix et on le fait vibrer
  var toastT;
  function pick(){
    var v = document.querySelector('form[action*="/cart/add"] .variants');
    if(!v) return false;
    var y = v.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    setTimeout(function(){
      v.classList.remove('lw-shake'); void v.offsetWidth; v.classList.add('lw-shake');
      setTimeout(function(){ v.classList.remove('lw-shake'); }, 600);
      var t = document.getElementById('lw-toast');
      if(t){ t.setAttribute('data-on','1'); clearTimeout(toastT); toastT = setTimeout(function(){ t.setAttribute('data-on','0'); }, 2200); }
      try{ if(navigator.vibrate) navigator.vibrate(40); }catch(e){}
    }, 380);
    return true;
  }
  function chosen(f){ return !!(f || document).querySelector('.vopt input:checked'); }
  function setQty(key, qty){
    if(!cartState) return;
    var it = cartState.items.filter(function(i){ return i.key === key; })[0];
    if(!it) return;
    qty = Math.max(0, qty);
    it.quantity = qty;
    if(qty === 0) cartState.items = cartState.items.filter(function(i){ return i.key !== key; });
    cartState.total_price = cartState.items.reduce(function(s,i){ return s + i.final_price * i.quantity; }, 0);
    render(cartState, true);
    pending++;
    queue = queue.then(function(){ return post('/cart/change.js', { id: key, quantity: qty }); })
      .then(function(c){ pending--; if(pending === 0) render(c); })
      .catch(function(){ pending--; refresh(); });
  }
  function packName(v){ return v && v.indexOf('3') > -1 ? 'Pack ×3 Intérieur' : '1 Flacon'; }
  function render(cart, optimistic){
    if(!itemsEl) return;
    if(!optimistic) cartState = cart;
    if(!cart.items || !cart.items.length){
      itemsEl.innerHTML = '<p class="dw-empty">Votre panier est vide.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(i){
        var pack = packName(i.variant_title);
        var sub = pack.indexOf('3') > -1 ? '3 × 500 ml · 🚚 livraison offerte' : '1 × 500 ml';
        return '<div class="dw-i" data-key="'+i.key+'">'
          + '<img src="'+(i.image||'')+'" alt="">'
          + '<div class="dw-c"><div class="t">'+pack+'</div><div class="s">Nettoyant Intérieur 3 en 1 — '+sub+'</div>'
          + '<div class="dw-q"><button type="button" data-act="dec" aria-label="Diminuer"'+(i.quantity<=1?' disabled':'')+'>−</button><b>'+i.quantity+'</b><button type="button" data-act="inc" aria-label="Augmenter">+</button><button type="button" class="dw-rm" data-act="rm">Supprimer</button></div></div>'
          + '<div class="pr">'+fmt(i.final_price * i.quantity)+'</div></div>';
      }).join('');
    }
    var t = cart.total_price || 0;
    if(totEl) totEl.textContent = fmt(t);
    if(barEl) barEl.style.width = Math.min(100, Math.round(t/THRESH*100)) + '%';
    if(shipEl) shipEl.innerHTML = t >= THRESH
      ? '🚚 <strong style="color:var(--ink)">Livraison offerte débloquée !</strong>'
      : '🚚 Plus que <strong style="color:var(--ink)">'+fmt(THRESH-t)+'</strong> pour la livraison offerte';
  }
  function refresh(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){ render(c); return c; });
  }
  function stepper(f){
    var qi = f.querySelector('input[name="quantity"]'); var row = f.querySelector('.lw-buy-row');
    if(!qi || !row || f.querySelector('.lw-qty')) return;
    var w = document.createElement('div'); w.className = 'lw-qty';
    w.innerHTML = '<span class="lw-qty-l">Quantité</span><div class="lw-qty-c"><button type="button" data-d="-1" aria-label="Diminuer">−</button><b>1</b><button type="button" data-d="1" aria-label="Augmenter">+</button></div>';
    row.parentNode.insertBefore(w, row);
    var b = w.querySelector('b');
    w.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var q = Math.max(1, Math.min(20, parseInt(qi.value,10) + parseInt(btn.dataset.d,10)));
        qi.value = q; b.textContent = q;
        w.querySelector('[data-d="-1"]').disabled = q <= 1;
      });
    });
    w.querySelector('[data-d="-1"]').disabled = true;
  }
  function addForm(f){
    if(!chosen(f)){ pick(); return Promise.resolve(); }
    var btn = f.querySelector('[name="add"]');
    var label = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Ajout…'; }
    var fd = new FormData(f);
    try{ if(window.fbq) fbq('track','AddToCart',{content_ids:[fd.get('id')],content_type:'product',num_items:parseInt(fd.get('quantity'),10)||1,currency:'TND'}); }catch(e){}
    return fetch('/cart/add.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){ open(); })
      .catch(function(){ f.submit(); })
      .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = label; } });
  }
  document.addEventListener('DOMContentLoaded', function(){
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(stepper);
    dw = document.getElementById('lw-drawer');
    if(dw){
      itemsEl = dw.querySelector('.dw-items');
      shipEl = dw.querySelector('.dw-ship-msg');
      barEl = dw.querySelector('.dw-bar span');
      totEl = dw.querySelector('.dw-total-val');
      dw.querySelector('.dw-bg').addEventListener('click', close);
      dw.querySelector('.dw-x').addEventListener('click', close);
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
      itemsEl.addEventListener('click', function(e){
        var b = e.target.closest('button[data-act]'); if(!b || !cartState) return;
        var key = b.closest('.dw-i').getAttribute('data-key');
        var it = cartState.items.filter(function(i){ return i.key === key; })[0]; if(!it) return;
        var act = b.getAttribute('data-act');
        setQty(key, act === 'inc' ? it.quantity + 1 : act === 'dec' ? it.quantity - 1 : 0);
      });
      refresh();
    }
    forms.forEach(function(f){
      f.addEventListener('submit', function(e){ e.preventDefault(); addForm(f); });
    });
    document.querySelectorAll('[data-lw-offer-add]').forEach(function(b){
      b.addEventListener('click', function(e){
        var f = forms[0];
        if(!f){ return; } // pas de sélecteur sur cette page : le lien mène à la fiche produit
        e.preventDefault();
        if(!chosen(f)){ pick(); return; }
        var label = b.textContent; b.style.pointerEvents = 'none'; b.textContent = 'Ajout…';
        addForm(f).finally(function(){ b.style.pointerEvents = ''; b.textContent = label; });
      });
    });
    document.querySelectorAll('[data-lw-pick]').forEach(function(b){
      b.addEventListener('click', function(e){
        if(pick()) e.preventDefault();
      });
    });
    document.querySelectorAll('[data-lw-cart]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); refresh(); open(); });
    });
  });
  window.lwCart = { refresh: refresh, open: open, close: close, state: function(){ return cartState; }, pick: pick, chosen: chosen };
})();
